const peiTypes = {
  UnSet: 0,
  Initial: 4,
  Revision: 5,
};

export default peiTypes;
